export const webviewFlipCard = () => {
  // ios
  try {
    window.webkit?.messageHandlers?.flipCard &&
      window.webkit.messageHandlers.flipCard.postMessage(true);
  } catch (e) {
    window.evite && window.evite.error('An error occurred in webviewFlipCard(ios): %O', e);
    window.Raven && window.Raven.captureException(e);
  }

  // android
  try {
    if (window.webview?.flipCard) window.webview.flipCard(true);
  } catch (e) {
    window.evite && window.evite.error('An error occurred in webviewFlipCard(ios): %O', e);
    window.Raven && window.Raven.captureException(e);
  }
};
